<p-toast [baseZIndex]="10000" position="center" [preventOpenDuplicates]="true" ></p-toast>
